import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './App.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { QueryClient, QueryClientProvider } from 'react-query';
import ThemeContextProvider from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext'; 
import { BrandProvider } from "./context/BrandContext";
import { I18nProvider } from "./i18n/I18nProvider";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // evita refetch duplicado em montagens rápidas (ex.: StrictMode/dev)
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retry: 1,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <I18nProvider>
      <ThemeContextProvider>
        <QueryClientProvider client={queryClient}>
          <BrandProvider>
            <App />
          </BrandProvider>
        </QueryClientProvider>
      </ThemeContextProvider>
    </I18nProvider>
  </AuthProvider>
);

reportWebVitals();
